import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    listUpload: [],
    loading: false
  },
  mutations: {
    addToList (state, payload) {
      state.listUpload = payload;
    },
    setLoading (state) {
      state.loading = !state.loading;
    }
  },
  actions: {
    toList (context, payload) {
      context.commit('addToList', payload);
    },
    setLoading (context) {
      context.commit('setLoading');
    }
  }
});
